import React, { useState } from "react";

const steps = [
  "Basic Details",
  "People",
  "Date & Location",
  "Operations",
  "Review & Save",
];

const GASCreateAppointment = () => {
  const [step, setStep] = useState(0);

  const [form, setForm] = useState({
    agenda: "",
    appointmentType: "Pre-booked",
    level: "Initial",
    organizer: "",
    teamMembers: "",
    mainInvitee: "",
    otherAttendees: "",
    date: "",
    time: "",
    venue: "",
    place: "",
    state: "",
    country: "",
    pin: "",
    latitude: "",
    longitude: "",
    securityInstructions: "",
    securityCode: "",
    housekeepingInstructions: "",
    housekeepingCode: "",
    pantryInstructions: "",
    pantryCode: "",
    remarks: "",
    callToAction: "",
  });

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const next = () => step < steps.length - 1 && setStep(step + 1);
  const prev = () => step > 0 && setStep(step - 1);

  return (
    <div className="min-h-screen bg-black text-cyan-400 px-4 py-6">
      <h2 className="text-xl font-semibold mb-4">Create Appointment</h2>

      {/* Step Indicator */}
      <div className="flex justify-between text-xs mb-6">
        {steps.map((s, i) => (
          <span
            key={i}
            className={`${
              i === step ? "text-cyan-300 font-bold" : "text-gray-500"
            }`}
          >
            {i + 1}. {s}
          </span>
        ))}
      </div>

      {/* Step Content */}
      <div className="border border-cyan-700 rounded-xl p-4">
        {/* STEP 1 */}
        {step === 0 && (
          <>
            <Input label="Agenda Title" name="agenda" onChange={handleChange} />
            <Select
              label="Appointment Type"
              name="appointmentType"
              options={["Pre-booked", "Walk-in"]}
              onChange={handleChange}
            />
            <Select
              label="Appointment Level"
              name="level"
              options={["Initial", "Escalation"]}
              onChange={handleChange}
            />
          </>
        )}

        {/* STEP 2 */}
        {step === 1 && (
          <>
            <Input label="Organizer" name="organizer" onChange={handleChange} />
            <Input
              label="Team Members"
              name="teamMembers"
              onChange={handleChange}
            />
            <Input
              label="Main Invitee"
              name="mainInvitee"
              onChange={handleChange}
            />
            <Input
              label="Other Attendees"
              name="otherAttendees"
              onChange={handleChange}
            />
          </>
        )}

        {/* STEP 3 */}
        {step === 2 && (
          <>
            <Input type="date" label="Date" name="date" onChange={handleChange} />
            <Input type="time" label="Time" name="time" onChange={handleChange} />
            <Input label="Venue" name="venue" onChange={handleChange} />
            <Input label="Place" name="place" onChange={handleChange} />
            <Input label="State" name="state" onChange={handleChange} />
            <Input label="Country" name="country" onChange={handleChange} />
            <Input label="PIN Code" name="pin" onChange={handleChange} />
            <Input label="Latitude" name="latitude" onChange={handleChange} />
            <Input label="Longitude" name="longitude" onChange={handleChange} />
          </>
        )}

        {/* STEP 4 */}
        {step === 3 && (
          <>
            <Textarea
              label="Security Instructions"
              name="securityInstructions"
              onChange={handleChange}
            />
            <Input
              label="Security Code"
              name="securityCode"
              onChange={handleChange}
            />
            <Textarea
              label="Housekeeping Instructions"
              name="housekeepingInstructions"
              onChange={handleChange}
            />
            <Input
              label="Housekeeping Code"
              name="housekeepingCode"
              onChange={handleChange}
            />
            <Textarea
              label="Pantry Instructions"
              name="pantryInstructions"
              onChange={handleChange}
            />
            <Input
              label="Pantry Code"
              name="pantryCode"
              onChange={handleChange}
            />
          </>
        )}

        {/* STEP 5 */}
        {step === 4 && (
          <>
            <Textarea
              label="Remarks"
              name="remarks"
              onChange={handleChange}
            />
            <Input
              label="Call To Action"
              name="callToAction"
              onChange={handleChange}
            />

            <div className="bg-cyan-900/20 border border-cyan-700 rounded-lg p-3 mt-4 text-xs">
              <pre className="whitespace-pre-wrap">
                {JSON.stringify(form, null, 2)}
              </pre>
            </div>
          </>
        )}
      </div>

      {/* Navigation */}
      <div className="flex justify-between mt-6">
        <button
          onClick={prev}
          disabled={step === 0}
          className="px-4 py-2 border border-cyan-600 rounded disabled:opacity-40"
        >
          Back
        </button>

        {step < steps.length - 1 ? (
          <button
            onClick={next}
            className="px-4 py-2 bg-cyan-600 text-black rounded"
          >
            Next
          </button>
        ) : (
          <button
            onClick={() => alert("Appointment saved (dummy)")}
            className="px-4 py-2 bg-green-500 text-black rounded"
          >
            Save Appointment
          </button>
        )}
      </div>
    </div>
  );
};

/* ---------- Reusable Inputs ---------- */

const Input = ({ label, ...props }) => (
  <div className="mb-3">
    <label className="block text-xs mb-1">{label}</label>
    <input
      {...props}
      className="w-full bg-black border border-cyan-700 rounded px-3 py-2 text-sm"
    />
  </div>
);

const Textarea = ({ label, ...props }) => (
  <div className="mb-3">
    <label className="block text-xs mb-1">{label}</label>
    <textarea
      {...props}
      rows="3"
      className="w-full bg-black border border-cyan-700 rounded px-3 py-2 text-sm"
    />
  </div>
);

const Select = ({ label, options, ...props }) => (
  <div className="mb-3">
    <label className="block text-xs mb-1">{label}</label>
    <select
      {...props}
      className="w-full bg-black border border-cyan-700 rounded px-3 py-2 text-sm"
    >
      {options.map((o, i) => (
        <option key={i}>{o}</option>
      ))}
    </select>
  </div>
);

export default GASCreateAppointment;
